/*
 *  -----------------------------------------------------------------------
 *    <copyright file="layouts.ts" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import React, { PropsWithChildren } from 'react';
import Loading from 'views/components/core/loading';
import AppLayout from 'views/layouts/app';
import LoginLayout from 'views/layouts/login/login';
import PublicLayout from 'views/layouts/public';
import { ILocalState } from '@contexts/local-state-context';
import { RouteLayoutType } from '@utils/router/router';
import { IRoute } from '@config/routes/interfaces';
import { KendoTheme } from '@config/theme';

export interface LayoutProviderProps extends PropsWithChildren {
    currentTheme: KendoTheme;
    layout: RouteLayoutType;
    route: IRoute | null;
    study: ILocalState['selectedStudy'];
}

const LayoutProvider = ({ layout, route, children, study, currentTheme }: LayoutProviderProps) => {
    switch (layout) {
        case 'PRIVATE':
            return (
                <AppLayout route={route} study={study} currentTheme={currentTheme}>
                    {children}
                </AppLayout>
            );
        case 'PUBLIC':
            return <PublicLayout>{children}</PublicLayout>;
        case 'LOGIN':
            return <LoginLayout>{children}</LoginLayout>;

        default:
            // Logger.log('Unknown layout: ', layout, route, children);
            return <Loading />;
    }
};

export default LayoutProvider;
